import {Injectable} from '@angular/core';
import {Lang} from '../model/lang.model';
import {ApiService} from './api.service';
import {retryAfterMillis} from '../shared/constants';
import {utf8Decode} from 'sdv-common';

@Injectable({providedIn: 'root'})
export class LanguageService {

  private languages: Lang[] = [];

  constructor(private apiService: ApiService) {
    this.load();
  }

  load() {
    this.apiService.get('languages', {
      $limit: 1000,
      $offset: 0
    }).subscribe(response => {
      const languages: Lang[] = [];
      for (const language of response) {
        languages.push(this.covertLanguage(language));
      }
      this.languages = languages;
    }, err => {
      this.apiService.error({}, err);
      setTimeout(() => this.load(), retryAfterMillis);
    });
  }

  private covertLanguage(language) {
    return {
      id: language.id || 0,
      name: utf8Decode(language.name || ''),
      originalName: utf8Decode(language.originalName || '')
    };
  }

  getLanguages() {
    return this.languages;
  }

  displayLanguage(language: Lang) {
    let display = language.name;
    if (language.name !== language.originalName) {
      display += ' (' + language.originalName + ')';
    }
    return display;
  }
}
